module.exports = jWeixin;


//////////////////
// WEBPACK FOOTER
// external "jWeixin"
// module id = 12
// module chunks = 8